import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/home/Hero';
import { TrustBar } from '../components/home/TrustBar';
import { IntentSelector } from '../components/home/IntentSelector';
import { Differentiation } from '../components/home/Differentiation';
import { BuyerSellerSplit } from '../components/home/BuyerSellerSplit';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { ComplexMatters } from '../components/home/ComplexMatters';
import { TeamAuthority } from '../components/home/TeamAuthority';
import { Proof } from '../components/home/Proof';
import { Resources } from '../components/home/Resources';
import { FAQ } from '../components/home/FAQ';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  useEffect(() => {
    document.title = 'Property Lawyers & Conveyancing Carlton Melbourne | L.A Property Law';
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Lawyer-led conveyancing and property law for Victorian buyers, sellers and investors. Contract reviews, Section 32 advice, SMSF matters and settlement support.');
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-1 w-full" data-id="element-675">
      <Hero data-id="element-676" />
      <TrustBar data-id="element-677" />
      <IntentSelector data-id="element-678" />
      <Proof data-id="element-679" />
      <Differentiation data-id="element-680" />
      <BuyerSellerSplit data-id="element-681" />
      <Process data-id="element-682" />
      <FeeTransparency data-id="element-683" />
      <ComplexMatters data-id="element-684" />
      <TeamAuthority data-id="element-685" />
      <Resources data-id="element-686" />
      <FAQ data-id="element-687" />
      <FinalCTA data-id="element-688" />
    </main>;
}